"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannedCommunityToJSON = exports.BannedCommunityFromJSONTyped = exports.BannedCommunityFromJSON = void 0;
function BannedCommunityFromJSON(json) {
    return BannedCommunityFromJSONTyped(json, false);
}
exports.BannedCommunityFromJSON = BannedCommunityFromJSON;
function BannedCommunityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'imgUrl': json['imgUrl'],
    };
}
exports.BannedCommunityFromJSONTyped = BannedCommunityFromJSONTyped;
function BannedCommunityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'imgUrl': value.imgUrl,
    };
}
exports.BannedCommunityToJSON = BannedCommunityToJSON;
